import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { RowItem } from '../layout/RowItem';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import Session from '../auth/Session'

function ClientDetails(props) {

    const navigate = useNavigate();

    const [clientId, setClientId] = useState(0);
    const [clientName, setClientName] = useState('');
    const [success, setSuccess] = useState(undefined);


    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            }
            else {
                if (props.location.state !== undefined) {
                    if (props.location.state.existingClient) {
                        const clientId = props.location.state.clientId;
                        setClientId(clientId);
                        getClientDetails(clientId);
                    }
                }
                else {
                    navigate('/admin/clients/create');
                }
            }
        }


        fetchIsAdmin();
    })

    const getClientDetails = async (clientId) => {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetClientDetailsAsync?id=${clientId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setState({
            clientName: data.name
        });
    }

    const editClient = async () => {
        const token = Session.getToken();
        const name = clientName;
        if (name) {
            const dto = {
                id: clientId,
                name: name
            };
            const response = await fetch('api/Admin/EditClientAsync', {
                method: 'POST',
                body: JSON.stringify(dto),
                headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            setSuccess(data);
        }
    }


    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <RowItem>
                    <Col xl='12'>
                        <h3>Client Details</h3>
                    </Col>
                    <Col xl='12'>
                        <h6>Client Id: {clientId}</h6>
                    </Col>
                </RowItem>
                <RowItem>
                    <Col xl='12'>
                        <h6>Edit Client Name</h6>
                    </Col>
                    <Col xl='10' lg='10' md='10' sm='10' xs='10'>
                        <Input
                            type='text'
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            name='clientName'
                            id='clientName'
                            placeholder='Name'
                        />
                    </Col>
                    <Col xl='2' lg='2' md='2' sm='2' xs='2'>
                        <Button
                            color='primary'
                            onClick={() => editClient()}
                        >
                            Save
                        </Button>
                    </Col>
                </RowItem>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        {success === true && (
                            <Alert color='success'>
                                Client saved successfully!
                            </Alert>
                        )}
                        {success === false && (
                            <Alert color='danger'>
                                Error saving Client!
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ClientDetails;